<header class="topbar">
    <div class="topbar-inner">
        <div class="brand">
            <app-logo Width="34" Height="34"></app-logo>
            <div class="brand-text">
                <span class="brand-title">CCDH</span>
                <span class="brand-sub">Sistema de Registro de Votación</span>
            </div>
        </div>

        <div class="user" *ngIf="userData">
            <span class="avatar">{{ (userData.user || '?').charAt(0) | uppercase }}</span>
            <span class="user-name">{{ userData.user }}</span>
            <button type="button" class="btn btn-ghost" (click)="fnCerrarSesion()">Cerrar sesión</button>
        </div>
    </div>
</header>

<main class="page" role="main" *ngIf="userData">
    <div class="page-head">
        <div>
            <h1 class="page-title">{{ mostrarReporte ? 'Reporte general' : 'Panel de asistencia' }}</h1>
            <p class="page-sub">Colegio de Cirujanos Dentistas de Honduras</p>
        </div>

        <div class="actions" *ngIf="userData['idRol']==1">
            <button *ngIf="mostrarReporte" type="button" class="btn btn-outline"
                onclick="GenerarArchivo('reporteGeneral','reporteGeneral')">Exportar a Excel</button>
            <button type="button" class="btn btn-primary" (click)="fnVerReporte()">
                {{ !mostrarReporte ? 'Ver reporte' : 'Volver al registro' }}
            </button>
        </div>
    </div>

    <app-dashboard asistenciaMesa={{asistenciaMesa}} porcentaje={{porcentaje}}
        totalEsperados={{totalEsperados}} totalAsistencias={{totalAsistencias}} presenciales={{presenciales}}
        representados={{representados}} pendientes={{pendientes}} rol="{{userData['idRol']}}">
    </app-dashboard>

    <app-loading *ngIf="cargando1"></app-loading>

    <ng-container *ngIf="!mostrarReporte">
        <section class="panel search">
            <label class="search-label" for="buscador">Buscar votante</label>
            <div class="search-row">
                <input id="buscador" type="text" class="search-input" [(ngModel)]="name"
                    placeholder="Nombre, No. de identidad o No. de colegiación"
                    (keyup.enter)="NuevaBusqueda(mymodal)">
                <button type="button" class="btn btn-primary" (click)="NuevaBusqueda(mymodal)">Buscar</button>
                <button type="button" class="btn btn-outline" *ngIf="personas.length>0 && userData['idRol']==2"
                    (click)="Agregar(mymodal)">+ Agregar</button>
            </div>
            <small class="search-help">Busque por nombre, número de identidad o número de colegiación.</small>
        </section>

        <app-loading *ngIf="cargando"></app-loading>

        <section class="results" *ngIf="personas.length>0">
            <app-tarjeta [personas]="personas"></app-tarjeta>
        </section>

        <div *ngIf="!cargando && personas.length>0" class="summary">
            <!-- USUARIO REGULAR -->
            <ng-container *ngIf="userData['idRol']==2">
                <div class="total">
                    <span class="total-label">Total a pagar</span>
                    <span class="total-value">Lps. {{personas.length*20}}.00</span>
                </div>
                <button type="button" class="btn btn-primary" (click)="guardar()">Guardar</button>
            </ng-container>

            <!-- PARA ADMINISTRADORES -->
            <ng-container *ngIf="userData['idRol']==1">
                <div class="total" *ngIf="personas.length>1">
                    <span class="total-label">Total a pagar</span>
                    <span class="total-value">Lps. {{valor}}.00</span>
                </div>
                <button type="button" class="btn btn-primary" (click)="fnHabilitar()">Habilitar</button>
            </ng-container>
        </div>
    </ng-container>

    <section class="panel" *ngIf="mostrarReporte">
        <app-report [data]="dataReport"></app-report>
    </section>
</main>

<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Lista de personas</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div>
            <input type="text" class="form-control mb-3" [(ngModel)]="filtroModal" (ngModelChange)="page = 1"
                placeholder="Filtrar por nombre, identidad, colegiación o estado">

            <table id="dtBasicExample" class="table">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Identidad</th>
                        <th>Número de colegiación</th>
                        <th>Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let persona of personasFiltradas | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
                       
                        <td>{{persona.nombre }}</td>
                        <td>{{persona.identidad }}</td>
                        <td>{{persona.numeroColegiacion}}</td>
                        <td>{{persona.status}}</td>
                        <td>
                            <button type="button" (click)="fnAgregar(persona)" class="btn btn-primary">+</button>
                        </td>
                    </tr>
                    <tr *ngIf="personasFiltradas.length == 0">
                        <td colspan="5" class="text-center">No hay coincidencias con el filtro</td>
                    </tr>
                </tbody>
            </table>

            <ngb-pagination class="d-flex justify-content-end" [(page)]="page" [pageSize]="pageSize"
                [collectionSize]="personasFiltradas.length" (pageChange)="pageChange($event,mymodal)">
            </ngb-pagination>
        </div>
    </div>
    <div class="modal-footer">
        <!--  <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
    </div>
</ng-template>
